import { useMemo } from "react";
import useSWR from "swr";
import {
  getCountryDetails,
  parseCountryCoordinate,
} from "@/api/country-details";

/**
 * Energy code details of a country. Pass the country slug, for example
 * `project.country`. Nothing is fetched while it is empty.
 */
const useCountryDetails = (country?: string | null) => {
  const { data, error, isLoading, mutate } = useSWR(
    country ? ["country-details", country] : null,
    () => getCountryDetails(country as string),
    // Country data rarely changes, so one request per country is enough.
    { shouldRetryOnError: false, revalidateOnFocus: false },
  );

  const coordinate = useMemo(
    () => parseCountryCoordinate(data?.coordinate),
    [data?.coordinate],
  );

  return { details: data ?? null, coordinate, error, isLoading, mutate };
};

export default useCountryDetails;
